import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const Interlude = ({ id, testid, image, alt, caption, quote, anchorBottom = false }) => {
  const ref = useRef(null);
  const prefersReducedMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(
    scrollYProgress,
    [0, 1],
    prefersReducedMotion ? ["0%", "0%"] : ["-6%", "6%"]
  );

  return (
    <section id={id} data-testid={testid} ref={ref} className="relative h-[37vh] sm:h-[72vh] overflow-hidden">
      {anchorBottom ? (
        <div className="absolute inset-0 img-grade">
          <img
            src={image}
            alt={alt}
            className="editorial-img"
            style={{ objectPosition: "bottom" }}
            loading="lazy"
          />
        </div>
      ) : (
        <motion.div style={{ y }} className="absolute inset-[-8%] img-grade">
          <img src={image} alt={alt} className="editorial-img" loading="lazy" />
        </motion.div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-black/15" aria-hidden="true" />

      {quote && (
        <div className="absolute top-10 sm:top-14 right-5 sm:right-12 max-w-[26ch] lg:max-w-none text-right">
          <p className="font-serif-heading italic text-xl sm:text-2xl lg:text-3xl leading-snug text-white drop-shadow-sm">
            {quote}
          </p>
        </div>
      )}

      {caption && (
        <div className="absolute bottom-6 left-5 sm:left-12">
          <p className="film-caption text-white/70">{caption}</p>
        </div>
      )}
    </section>
  );
};

export const InterludeOne = () => (
  <Interlude
    id="interlude-1"
    testid="interlude-1-section"
    image="https://customer-assets.emergentagent.com/job_pond-education-hub/artifacts/bpy2a2zi_cfe67973-db7a-46b3-a707-2617ff5f6589%20%281%29.png"
    alt="Aerial view of an Alberta acreage with a private pond surrounded by trees and farmland"
    quote={
      <>
        “Every pond is a promise
        <br className="hidden lg:block" /> you make to your land.”
      </>
    }
  />
);
